import React from 'react';
import './../Apps.css';
import DragDrop from './../DragDrop';

const Mortality = ({name}) => {
    return (
        <DragDrop appName = {name} />
    );
};

export default Mortality;